<template>
    <div class="btn-group dealer-locator__result--opening-hours-container">
        <Dropdown 
            :disabled="!hasTimes" 
            contentClass="dealer-locator__result--service-hours-container"
            v-model="isOpen"
        >
            <template #trigger>
                <button 
                    type="button" 
                    class="dealer-locator__result--opening-hours"
                    :class="dealer.is_open ? 'open' : 'closed'"
                >
                    <p v-html="dealer.is_open_with_time" />
                    <span  
                        v-if="hasTimes"
                        class="arrow"
                    >
                        <Caret :open="isOpen"/>
                    </span>
                </button>
            </template> 

            <template #options>
                <li
                    v-for="(hours, type) in dealer.opening_times_array_key_value" 
                    :key="`hours:${type}`"

                    class="dealer-locator__result--service-hours"
                >
                    <span class="type">{{ getTypeLabel(type) }}</span>
                    <template v-for="(hoursForDay, day) in hours">
                        <span class="day">{{ day }}</span>
                        <span class="hours">{{ hoursForDay }}</span>
                    </template>
                </li>
            </template>
        </Dropdown>
    </div>
</template>

<script>
    import { defineComponent } from "vue";
    import Caret from "../../../icons/Caret.vue";
    import Dropdown from "../../../components/forms/Dropdown.vue";

    export default defineComponent({
        name: 'OpeningHours',

        components: {
            Caret,
            Dropdown
        },

        props: {
            dealer: Object
        },

        data(){
            return {
                isOpen: false
            }
        },

        computed: {
            hasTimes: function(){
                return typeof this.dealer.opening_times_array_key_value === 'object' && Object.values(this.dealer.opening_times_array_key_value).length > 0
            }
        },

        methods: {
            getTypeLabel: function(type){
                if (type === 'sales' && (this.dealer.is_used_only === true)) {
                    return 'Sales - Used Vehicles Only'
                }

                return typeof type === 'string'
                    ? type.charAt(0).toUpperCase() + type.slice(1)
                    : type
            },
            onClick: function(){
                this.isOpen = !this.isOpen
            },
            onClose: function(){
                this.isOpen = false
            }
        }
    })
</script>